import styles from './WaveLoader.module.less'

export const WaveLoader: React.FC = () => {
    return <div className={styles['loader']}></div>
}
